import React, { Fragment, useEffect, useState } from 'react'
import "./Page.css"
import PageCard from '../../Components/PageComponents/PageCard'
import { useDispatch, useSelector } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {  faMagnifyingGlass, faXmark } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import { Backdrop, Fade, Modal } from '@mui/material';
import {  addPageTokenAPI, getAllTokensAPI, getAllTokensNextAPI, getHasNextPageCard } from '../../RTK/Slice/PageSlice.js';
import { STATUS } from '../../Constants.js';
import Skeleton from 'react-loading-skeleton';
import { toast } from 'react-toastify';
import { getActiveToken } from '../../RTK/Slice/Auth/AuthSlice.js';
import { notEmpty } from '../../Validation.js';

const AllPage = () => {

  // For Get Access Token
  const AccessToken = useSelector(state => state.AuthSlice.Auth?.token) ; 

  // For Dispatch Action 
  const dispatch = useDispatch() ; 

   // For Render Token
   const {  pageAccessTokens,status} = useSelector(state => state.PageSlice) ;

  // For Translation
  const {t } = useTranslation() ;

  // For Access Overlay Input
  const [pageToken ,setPageToken] = useState('') ;
  const [pageId , setPageId] = useState('') ; 
  const [pageName , setPageName] = useState('') ;


  // For Modal Style
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    p: 4,
  };

  // For Control Reply Modal
  const [open, setOpen] = useState(false);
  // const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  // For rest fields
  const restFields = ()=>{
    setPageId('');
    setPageToken("") ;
    setPageName("")
  }

  // For Add Token Handler 
  const addTokenHandler = ()=>{
    if(pageId !== '' && pageName !== '' && pageToken !== '' ){
      dispatch(addPageTokenAPI({token : AccessToken , params : {
        pageToken,
        pageName  ,
        pageId :pageId
      }}));
      restFields() ; 
      handleClose() ;
    }else{
      toast.info("Please Fill Data ")
    }
  }

  // For Render Reply Modal
  const addPageTokenModal = ()=>{
      return (
          <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          open={open}
          onClose={handleClose}
          closeAfterTransition
          slots={{ backdrop: Backdrop }}
          slotProps={{
            backdrop: {
              timeout: 300,
            },
          }}
        >
          <Fade in={open}>
              <div className='k-modal my-font' style={style}>

                  <div className='head'>
                      <div className='left'>
                          <h3>{t('addPageToken')}</h3>
                          <p>{t('addPageTokenDetails')}</p>
                      </div>
                      <div className='right' onClick={handleClose} ><FontAwesomeIcon  icon={faXmark} /></div>
                  </div>
                  <div className='body'>

                      <div className='write-message-con'>
                          <label className='' htmlFor='message-input'>{t("pageName")} </label>
                          <input value={pageName} onChange={(e)=>setPageName(e.target.value) } autoFocus className='normal-input' placeholder='Page Name' />
                      </div>
                      <div className='write-message-con'>
                        <label className='' htmlFor='message-input'>{t("pageId")} </label>
                        <input value={pageId} onChange={(e)=> setPageId(e.target.value)} className='normal-input' placeholder='Page ID' />
                      </div>
                      <div className='write-message-con'>
                        <label className='' htmlFor='message-input'>{t("pageToken")} </label>
                        <input value={pageToken} onChange={(e)=>setPageToken(e.target.value)} className='normal-input' placeholder='Page Token' />
                      </div>

                  </div>

                  <div className='btn'>
                      <button onClick={addTokenHandler} >{t('add')}</button>
                  </div>

              </div>
              
          </Fade>
      </Modal>
      )
  }

  // For Get Active Token 
  const activeToken = useSelector(getActiveToken) ; 
  


  // For Get All Token Called
  useEffect(()=>{
    if(notEmpty(activeToken))
      dispatch(getAllTokensAPI({token :AccessToken , userToken: activeToken})) ;
    // if(status === STATUS.UNAUTHORIZED && AccessToken !== null){
    //   dispatch(logout()) ; 
    //   window.location.href = '/login';
    //    toast.error("Login and try again ")
    //  }
  } , [dispatch , AccessToken  ]) ; 



  // useEffect(()=>{
  //   if(status === STATUS.ERROR){
  //     dispatch(logout() ) ;
  //     dispatch(returnToSafeStatus()) ; 
  //   }else{
      
  //   }
  // },[status , dispatch ])

 

  // For Access Search Input
  const [search , setSearch] = useState('') ; 

  const hasNext = useSelector(getHasNextPageCard) ; 

  const getNextPageHandler = ()=>{
    dispatch(getAllTokensNextAPI({userToken : activeToken , nextToken : hasNext , token:AccessToken}))
  }




  // To Render All Page Tokens
  const mapPageTokens = ()=>{
    return (
      <Fragment>
      {
       pageAccessTokens?.length > 0?
        pageAccessTokens
        ?.filter((item)=>{
          return search === '' ? item : item.name?.toLowerCase().includes(search)
        })
        ?.map((item )=>{
          return (
            <PageCard key={item.id} tokenId={item.id} pageId={item?.id} title={item?.name ? item?.name : "Not Specified"} accessToken={item?.access_token} />
          )
        }) :<h2>Not Found</h2>
      }
      </Fragment>
    )
  }

  return (
    <section className='all-page-section'>
        {addPageTokenModal()}
        <div className='searh-page-token'>
          <div className='search-bar'>
            <FontAwesomeIcon icon={faMagnifyingGlass}  />
            <input value={search} onChange={(e)=> setSearch(e.target.value)} placeholder={t("search")} />
          </div>
          <div className='btn-group'>
            {/*<button onClick={handleOpen}>  {t("addTokenPage")} <FontAwesomeIcon icon={faPlus} /> </button>*/}
          </div>
        </div>
        
          
          { status === STATUS.SUCCESS ?
            mapPageTokens() 
            :
            status === STATUS.LOADDING ?
            (<Skeleton count={4} style={{width :"644px" , maxWidth : "100%" , height :"80px" ,borderRadius : "8px"}} />) :""
          }

          {/* For Pagination Next and Before */}
            
            <div className="main-pagination">
                <div className="pagination-btn">
                </div>
                <div className="pagination-btn">
                    {hasNext ? (<button className="btn-pag" onClick={getNextPageHandler} >Next</button>) : ""}
                    
                </div>
            </div>
        

    </section>
  )
}

export default AllPage
